// extracted by mini-css-extract-plugin
export default {"modal":"videoModal_modal__51m5K","modalContent":"videoModal_modalContent__10IQs","close":"videoModal_close__vOBwe"};